<div class="igntr-theme max-w-[1280px] mx-auto bg-[--background-color]">
  <form [formGroup]="form" (ngSubmit)="saveChanges()">
    <div class="p-7 space-y-5">
      <div class="flex items-start justify-between mb-4">
        <div class="flex items-start gap-2.5">
          <div
            class="w-8 h-8 rounded-lg bg-white border !border-slate-200 flex items-center justify-center !text-slate-700"
          >
            <igntr-icon name="sparkle"></igntr-icon>
          </div>
          <div>
            <div class="text-[14px] font-semibold !text-slate-900">
              {{ "description" | transloco }}
            </div>
            <div class="text-[12px] !text-slate-500 mt-0.5">
              {{ "whatThisOrganisation" | transloco }}
            </div>
          </div>
        </div>
        <button
          type="submit"
          class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium"
        >
          {{ "save" | transloco }}
        </button>
      </div>
      <div
        *ngFor="let item of itemsToRename; let i = index"
        class="rounded-xl border !border-slate-200/70 bg-white"
      >
        <div class="px-3.5 py-3 border-b !border-slate-100">
          <span class="text-[14px] font-bold !text-slate-700">{{
            item.name
          }}</span>
          <div class="text-[14px] font-medium !text-slate-700 mt-2">
            {{ "customTitle" | transloco }}
          </div>
          <div>
            <input
              formControlName="customTitle-{{ i }}"
              type="text"
              class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
            />
          </div>
        </div>
        <div class="px-3.5 py-3 border-b !border-slate-100">
          <div class="form-group form-floating mb-3">
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "customDescription" | transloco }}
            </div>
            <div class="form-floating">
              <p-editor
                class="editor"
                [style]="{ minHeight: '80px' }"
                formControlName="customDescription-{{ i }}"
              >
                <ng-template pTemplate="header">
                  <app-editor
                    loadData
                    skipFeatureGate
                    [allowSprintInsert]="true"
                    [allowOnboardingInsert]="true"
                    [allowRoleplayInsert]="true"
                    [allowToolboxInsert]="true"
                    [sprints]="sprints"
                    [onboardings]="onboardings"
                    [roleplays]="roleplays"
                    [toolboxAreas]="toolboxAreas"
                    [tenant]="tenant"
                  ></app-editor
                ></ng-template>
              </p-editor>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<!-- <ng-template #editorToolbar>
  <span class="ql-formats">
    <select class="ql-header" aria-label="Header">
      <option selected></option>
      <option value="1">Heading 1</option>
      <option value="2">Heading 2</option>
    </select>

    <button type="button" class="ql-bold" aria-label="Bold"></button>
    <button type="button" class="ql-italic" aria-label="Italic"></button>

    <button
      type="button"
      class="ql-list"
      value="ordered"
      aria-label="Numbered List"
    ></button>
    <button
      type="button"
      class="ql-list"
      value="bullet"
      aria-label="Bullet List"
    ></button>
  </span>
</ng-template> -->
